import { componentClasses, defaultProps, views } from "../../../../core/components/table/head/cell";
import { tableCellTemplate } from "../body/cell.template";
import { prefix, randomNumGenerator, removeLineBreak } from "../../../../core/js/utilities";
import { types as sortType } from "../../../../core/js/data-grid/sort-by-column";
import { mergeStates, renderState } from "../../../../core/js/state-machine";
import { actionButtonTemplate } from "./action.template";

export const resizeHandleTemplate = () => {
    return `<div class="${prefix}th__resize-handle"></div>`;
};

/**
 * Wraps the body of the cell with the main cell wrapper
 * @param {{value:String,sortBy:String,align:String}} config
 * @param {String} body
 * @returns {String} <div class attrs>{body}</div>
 */
export const mainWrapperTemplate = (config, body) => {
    const viewToRender = renderState(
        mergeStates(
            views.rest,
            views.align[config.align],
            config.sortBy && views.withAction,
            views.sortBy.wrapper[config.sortBy]
        )
    );
    return removeLineBreak(`<div class="${viewToRender.classList.join(" ")}" ${viewToRender.attrs}>
        ${body}
    </div>`);
};

/**
 * Creates head cell html content based on config
 * @param {{sortBy:String,value:String}} config
 * @return default html for plain text head or button
 */
export default (config = {}) => {
    const hasSort = config.sortBy in sortType ? true : false;
    const hasPin = config.pinnable ? true : false;
    const hasAction = hasSort || hasPin;

    const resizeHandler = config.resizable ? resizeHandleTemplate() : "";

    if (hasAction) {
        const actionId = `action-button-${randomNumGenerator()}`;
        const value = config.value;
        const sortLabel = defaultProps.sort.labels[config.sortBy];
        const a11yElement = sortLabel
            ? `<div id="${actionId}-sr" class="${componentClasses.buttonScreenReader}">${sortLabel}</div>`
            : "";
        const template = actionButtonTemplate({
            actionId,
            value,
            sortBy: config.sortBy,
            pinnable: config.pinnable,
            pinned: config.pinned,
        });

        return mainWrapperTemplate(
            config,
            removeLineBreak(`${a11yElement}${template}${resizeHandler}`)
        );
    }

    return mainWrapperTemplate(config, `${tableCellTemplate(config)}${resizeHandler}`);
};
